import { render, staticRenderFns } from "./RatingIconDefault.vue?vue&type=template&id=1f7d3732&"
import script from "./RatingIconDefault.vue?vue&type=script&lang=ts&"
export * from "./RatingIconDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports